import { render, staticRenderFns } from "./Spesialisasi.vue?vue&type=template&id=7d362c63"
import script from "./Spesialisasi.vue?vue&type=script&lang=js"
export * from "./Spesialisasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports